import { render, staticRenderFns } from "./select-material-content.vue?vue&type=template&id=a7278f04&scoped=true&"
import script from "./select-material-content.vue?vue&type=script&lang=js&"
export * from "./select-material-content.vue?vue&type=script&lang=js&"
import style0 from "./select-material-content.vue?vue&type=style&index=0&id=a7278f04&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7278f04",
  null
  
)

export default component.exports